/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Export_ButtonInputs */



/**
* | output |
* | --- |
* | "Export Video" |
*
* @param {Video_Export_Export_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_export_button = /** @type {((inputs?: Video_Export_Export_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Export_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter la video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Video exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт видео")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出视频")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオをエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar vídeo")
	return /** @type {LocalizedString} */ ("Export Video")
});